import './statIcon.scss'

export const StatIcon = ({ iconSrc, number, unit }: {iconSrc: string, number: string, unit: string}) => (
  <div className="stat-icon-container">
    <img className="stat-icon-img" src={iconSrc} />
    <h1 className="stat-icon-number">{number}</h1>
    <h2 className="stat-icon-unit">{unit}</h2>
  </div>
);
